import React, { useEffect } from "react";
import "../styles/Admin.css";

export default function Admin() {
  useEffect(() => {
    window.location.href = "/admin/";
  }, []);

  return (
    <div className="admin-container">
      <div className="admin-card">
        <h2>Redirecting to Admin Panel...</h2>
        <p>
          If you are not redirected automatically,{" "}
          <a href="/admin/">click here</a>.
        </p>
      </div>
    </div>
  );
}
